import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useContext } from 'react';

import { AppContext } from '../context/AppContext';
import { useState } from 'react';

const Header = ({titletext}) => {

    const { setToken, token, setUser, currentUser, setLoadingApp } = useContext(AppContext);    
    const [shouldRedirect, setShouldRedirect] = useState(false);


    const adminlogoutClick = () => {
        localStorage.clear();  
        setUser("");
      }

    
  return (
    <>
     <Row className="justify-content-center">
    <Col className='col-2'>
        <img src="/mahamevnawalogo.png" alt="mahamevnawa London" height="65px" style={{ marginBottom: "3px" }} />
    </Col>
    <Col className='col-8'>
        <h2> <b>නමෝ බුද්ධාය</b> - <b>{currentUser.TenantName}</b> අසපුව - <b>{titletext}</b></h2>
    </Col>
</Row>

{(currentUser.accesstype ==="admin" || currentUser.accesstype ==="superadmin") &&
<>  
    <Row>
        <hr></hr>  
        <Col className='col-9 text-end'>        
            <>Login as <b>{currentUser.name.toString()}</b> &nbsp; <Button size='sm' variant="outline-warning" onClick={adminlogoutClick}>Log Out</Button></>         
        </Col>
        {titletext !== 'Administration' && 
            <Col className='col-2 text-end'> 
                <Link to="/"><Button variant="outline-success" size='sm' >Back to Main Menu</Button></Link>  
            </Col>
        }
        <hr></hr>   
    </Row>     
</>}

    </>
  )
}

export default Header